import clsx from 'clsx';
import React from 'react';
import { RadioButtonProps } from './RadioButton.types';

export const RadioButton = ({
  inputs,
  groupLabel,
  hasError,
  showInline,
  showBlock,
  theme,
}: RadioButtonProps): JSX.Element => {
  if (!inputs?.length) return null;
  return (
    <fieldset
      data-theme={theme}
      className={clsx('form-element', 'hg-radio-button', {
        'has-error': hasError,
      })}
    >
      {groupLabel && (
        <legend className={clsx('form-element__legend', 'form-element__label')}>
          {groupLabel}
        </legend>
      )}

      <div
        className={clsx('form-element__control', {
          'form-element__control_inline': showInline,
        })}
      >
        {inputs.map(({ label, labelDescription, ...input }) => {
          return (
            <span
              key={input.id}
              className={clsx('hg-radio-button', {
                'hg-radio-button__block': showBlock,
              })}
            >
              <input type='radio' {...input} />
              <label className='hg-radio-button__label' htmlFor={input.id}>
                <span className='hg-radio-button__checkmark'></span>
                <span className='form-element__labels'>
                  <span className='form-element__label'>{label}</span>
                  {showBlock && labelDescription && (
                    <span className='form-element__label-description'>
                      {labelDescription}
                    </span>
                  )}
                </span>
              </label>
            </span>
          );
        })}
      </div>

      {hasError && (
        <div className='hg-radio-button form-element__help'>{hasError}</div>
      )}
    </fieldset>
  );
};
